export class RefreshTokenModel {
    /**
     * Refresh Token usuario
     */
    refreshToken: string;
}
